module.exports = __webpack_public_path__ + "img/Photo_2__Construction_986_82_245.0d39849a.jpg";